import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

interface StyleProps {
  marginVertical?: number;
  fontSize?: number;
}

type ErrorMessageProps = StyleProps & {
  children: string | React.ReactNode;
};

export const ErrorMessage = (props: ErrorMessageProps) => (
  <StyledErrorMessage marginVertical={props.marginVertical} fontSize={props.fontSize}>
    {props.children}
  </StyledErrorMessage>
);

type ValidationPropsProps = StyleProps & {
  messages?: string[];
};

export const ValidateMessageIfError = (props: ValidationPropsProps) => {
  return props.messages && props.messages.length > 0 ? (
    <ErrorMessage marginVertical={props.marginVertical} fontSize={props.fontSize}>
      {props.messages.map((message, index) => (
        <span key={index}>{message}</span>
      ))}
    </ErrorMessage>
  ) : null;
};

const StyledErrorMessage = styled.p<StyleProps>`
  font-size: ${({ fontSize }) => `${fontSize ? fontSize : 10}px`};
  line-height: 1.5;
  color: ${StyleConfig.COLOR.SECONDORY};
  margin-top: ${({ marginVertical }) => {
    const m = marginVertical ? marginVertical : 0;
    return `${m}px`;
  }};
  margin-bottom: ${({ marginVertical }) => {
    const m = marginVertical ? marginVertical : 0;
    return `${m}px`;
  }};
  > span {
    display: block;
  }
`;

export default ErrorMessage;
